// pages/InvoiceRedirect.js
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config";

export default function InvoiceRedirect() {
  const { token } = useParams();

  useEffect(() => {
    if (!token) return;

    const fetchInvoice = async () => {
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/invoice/getInvoiceData/${token}`
        );


        if (res.data?.status && res.data?.data?.invoice_url) {
          // Redirect to S3 invoice PDF
          window.location.href = res.data.data.invoice_url;
        } else {
          alert("Invalid or expired invoice link");
        }
      } catch (error) {
        console.error(error);
        alert("Unable to load invoice");
      }
    };

    fetchInvoice();
  }, [token]);

  return <p>Loading invoice…</p>;
}
